// import _map from 'lodash/map';
import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_ASYNC_OPERATIONS_LIST,
  GET_INSTALLATION_ASYNC_OPERATION_HISTORY,
  WS_RECEIVED_ASYNC_RESULT,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/installationAsyncOperation';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationAsyncOperation;
const installationAsyncOperation = (state = initialSettings, action) => {
  // let asyncOperation;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
        };
      }
      return state;
    // Treat RECEIVED_ASYNC_RESULT operations from webSocket
    case WS_RECEIVED_ASYNC_RESULT:
      return state;
      // asyncOperation = action.asyncOperation;
      // return {
      //   ...state,
      //   list: {
      //     ...state.list,
      //     elements: {
      //       ...state.list.elements,
      //       data: _map(state.list.elements.data, (ao) => (ao.id === action.id
      //         ? {
      //           ...ao,
      //           devices: asyncOperation.devices,
      //           rollback_status: asyncOperation.rollback_status,
      //           status: asyncOperation.status,
      //         } : ao
      //       )),
      //     },
      //   },
      // };
    // LIST
    case GET_INSTALLATION_ASYNC_OPERATIONS_LIST:
      // Note: Display loading and reset data only if the action is asked by user (i.e. desynchronized is false)
      return {
        ...state,
        list: {
          ...state.list,
          loading: !action.desynchronized,
          desynchronized: false,
          error: null,
          elements: {
            ...state.list.elements,
            data: action.desynchronized ? [...state.list.elements.data] : null,
          },
        },
        installations: {
          ...state.installations,
          [action.cbParams.id]: {
            loading: true,
            data: null,
          },
        },
      };
    case `${GET_INSTALLATION_ASYNC_OPERATIONS_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          desynchronized: false,
          error: action.error,
        },
      };
    case `${GET_INSTALLATION_ASYNC_OPERATIONS_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          desynchronized: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
        installations: {
          ...state.installations,
          [action.id]: {
            loading: false,
            data: deserialize(action.data.data),
          },
        },
      };
    // HISTORY
    case GET_INSTALLATION_ASYNC_OPERATION_HISTORY:
      return {
        ...state,
        history: {
          ...state.history,
          loading: true,
          error: null,
          elements: {
            ...state.history.elements,
            data: null,
          },
        },
      };
    case `${GET_INSTALLATION_ASYNC_OPERATION_HISTORY}_ERROR`:
      return {
        ...state,
        history: {
          ...state.history,
          loading: false,
          error: action.error,
        },
      };
    case `${GET_INSTALLATION_ASYNC_OPERATION_HISTORY}_SUCCESS`:
      return {
        ...state,
        history: {
          ...state.history,
          loading: false,
          elements: {
            ...state.history.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    default:
      return state;
  }
};

export default installationAsyncOperation;



// WEBPACK FOOTER //
// ./reducers/installation/installationAsyncOperation.js